import React, { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useCadastroProducao } from '../../../hook/useCadastroProducao';
import { InputPercent, InputPeso } from '~/components/NovosInputs';
import { useHandleFocus } from '~/pages/CadastroDePoducao/hook/useHandleFocus';
import { transformAsCurrency } from '~/utils/functions';
import { calculaSubTotal } from '~/pages/CadastroDePoducao/functions/calcSubTotal';
import { moedaFormatada } from '~/components/NovosInputs/InputMoney/formatMask';
import { insertOrUpdate } from '~/utils/masterDetail';
import { calcUnitario } from '~/pages/CadastroDePoducao/functions/calcUnit';

export const InputsForm: React.FC = () => {
  const {
    formProducao,
    setProdutosRows,
    setValCustoFinal,
    produtosRows,
    qtdTotReceita,
    setQtdRendeKg,
    setQtdTotProducao,
    setQtdTotReceita,
    setCustoSemImposto,
    setValCustoReceita,
    setValCustoProducao,
    masterDetail,
    setMasterDetail,
  } = useCadastroProducao();
  const { control, register, formState, getValues, setValue } = formProducao;
  const { errors } = formState;
  const { handleInputFocus } = useHandleFocus();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const recalcularItens = async () => {
    // timeOut para chamar as funções de calculo apenas 1 vez, após o tempo estipulado
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(async () => {
      const { qtd_rendimento, per_despesa_producao } = getValues();
      const updatedRows = produtosRows.map((item: any) => {
        const { uuid, id } = item;
        const itemQtdReceita = transformAsCurrency(item.qtd_receita);
        const resultCalcUnit = calcUnitario({
          produtoAtual: item,
          qtdReceita: itemQtdReceita,
          totQtdReceita: qtdTotReceita,
          qtdRendimento: transformAsCurrency(qtd_rendimento),
        });

        return {
          ...item,
          uuid,
          id,
          qtd_producao: resultCalcUnit.qtdProducao,
          qtd_rendimento: resultCalcUnit.qtdRendeKg,
          custoSemImpostoFinal: resultCalcUnit.custoSemImpostoFinal,
          custoFinal: resultCalcUnit.custoFinal,
        };
      });

      const updatedMasterDetail = await updatedRows.reduce(
        async (previousPromise, updatedRow) => {
          const currentMasterDetail = await previousPromise;

          return insertOrUpdate(
            'produtos',
            updatedRow,
            currentMasterDetail,
            setMasterDetail,
          );
        },
        Promise.resolve(masterDetail),
      );

      setProdutosRows(updatedRows);

      const resultadoCalcSubTotal = calculaSubTotal({
        itens: updatedRows,
        perDespesaProducao: transformAsCurrency(per_despesa_producao),
      });

      setQtdRendeKg(resultadoCalcSubTotal.rendeKg);
      setQtdTotProducao(resultadoCalcSubTotal.totQtdProducao);
      setQtdTotReceita(resultadoCalcSubTotal.totQtdReceita);
      setCustoSemImposto(resultadoCalcSubTotal.custoSemImp);
      setValCustoFinal(resultadoCalcSubTotal.custoFinalProducao);
      setValCustoReceita(resultadoCalcSubTotal.custoReceita);
      setValCustoProducao(resultadoCalcSubTotal.custoProducao);
    }, 500);
  };

  return (
    <Row>
      <Col sm={12} md={6}>
        <InputPeso
          label="Rendimento Kg"
          placeholder="0,000"
          name="qtd_rendimento"
          decimals={3}
          max={9999}
          min={0}
          maxLength={12}
          control={control}
          register={register}
          isError={!!errors.qtd_rendimento}
          onKeyPress={async (event: any) => {
            if (event.key === 'Enter') {
              handleInputFocus('per_despesa_producao');
            }
          }}
          onInput={(val: any) => {
            setValue('qtd_rendimento', moedaFormatada(val.target.value, 3));
            recalcularItens();
          }}
        />
      </Col>
      <Col sm={12} md={6}>
        <InputPercent
          label="Outras Despesas"
          placeholder="0,00"
          name="per_despesa_producao"
          decimals={2}
          max={9999}
          min={0}
          maxLength={15}
          control={control}
          register={register}
          isError={!!errors.per_despesa_producao}
          onKeyPress={async (event: any) => {
            if (event.key === 'Enter') {
              handleInputFocus('busca_produto');
            }
          }}
          onInput={(val: any) => {
            setValue(
              'per_despesa_producao',
              moedaFormatada(val.target.value, 2),
            );
            recalcularItens();
          }}
        />
      </Col>
    </Row>
  );
};
